import React from "react";
import { Link, useParams } from "react-router-dom";

import PageTitle from "../../../../layouts/PageTitle";
import { useGetSupplierByIdQuery } from "../../../../../store/appApi";

function SupplierDetailView() {
  const { id } = useParams();
  const { data: supplierResponse, isLoading, isError } = useGetSupplierByIdQuery(id, { skip: !id });
  const supplier = supplierResponse?.supplier || null;

  if (isLoading) {
    return (
      <div className="row">
        <div className="col-12"><p>Loading supplier...</p></div>
      </div>
    );
  }

  if (isError || !supplier) {
    return (
      <div className="row">
        <div className="col-12"><p className="text-danger">Failed to load supplier details.</p></div>
      </div>
    );
  }

  const createdAt = supplier.created
    ? new Date(supplier.created).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "—";

  const details = [
    { title: "Supplier Name", subtitle: supplier.name || "—" },
    { title: "GST Number", subtitle: supplier.gstNumber || "—" },
    { title: "Address", subtitle: supplier.address || "—" },
    { title: "Added On", subtitle: createdAt },
  ];

  return (
    <div className="row">
      <div className="col-xl-4 col-lg-4 col-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title" style={{ textTransform: "capitalize" }}>
              {supplier.name}
            </h4>
          </div>
          <div className="card-body pb-0">
            <ul className="list-group list-group-flush">
              {details.map((item, ind) => (
                <li
                  className="list-group-item d-flex px-0 justify-content-between"
                  key={ind}
                >
                  <strong>{item.title}</strong>
                  <span className="mb-0 text-end" style={{ maxWidth: "60%" }}>
                    {item.subtitle}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="card-footer text-center border-0">
            <Link to={`/edit-supplier/${id}`} className="btn btn-primary px-4">
              Edit Supplier
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const SupplierProfile = () => {
  return (
    <>
      <PageTitle activeMenu="Supplier Profile" motherMenu={"Inventory"} />
      <SupplierDetailView />
    </>
  );
};

export { SupplierDetailView };
export default SupplierProfile;
